module.exports = "/_next/static/images/bgImageProudMembers-b1557ba5d78c04a045576d65b981abeb.webp";